<template>

    <svg width="10"
         height="6"
         viewBox="0 0 10 6"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         class="down-caret"
         :class="{ '--upwards': upwards }">

        <path d="M1 1L5 5L9 1"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>

    </svg>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'DownCaret',
        props: {
            upwards: {
                type: Boolean, default: false
            }
        }
    })

</script>

<style lang="scss">

    @include component(down-caret) {

        transition: transform 300ms ease;

        @include option(upwards) {

            transform: rotate(180deg);
            transform-origin: 50% 50%;

        }

    }

</style>
